var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.45)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "5px"
  }, /*#__PURE__*/React.createElement("polygon", {
    strokeLinejoin: "round",
    transform: "translate(-15.63,-27.5)",
    points: "50.17 69.56 30.82 59.27 30.82 40.73 50.17 30.44"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m10.61 13.225h4.58v18.55h-4.58c-4.47 0-8.11-3.63-8.11-8.11v-2.33c0-4.47 3.63-8.11 8.11-8.11z"
  }), /*#__PURE__*/React.createElement("line", {
    strokeMiterlimit: 10,
    x1: 47.93,
    x2: 62.76,
    y1: 15.09,
    y2: 29.91
  }), /*#__PURE__*/React.createElement("line", {
    strokeMiterlimit: 10,
    x1: 47.92,
    x2: 62.81,
    y1: 29.95,
    y2: 15.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOff);
export default __webpack_public_path__ + "static/media/audio-off.280f282c.svg";
export { ForwardRef as ReactComponent };